module.exports = __webpack_public_path__ + "static/media/cq_upload_nero.d2d488cc.svg";